import { useEffect, useState } from "react";
import { deleteCategory, getCategory } from "../../../shared/services/services";
import { errorHandling } from "src/shared/services/errorHandling";
import { closeLoading, notifyLoading, notifySuccess } from "src/assets/toastService";
import { CategoryV2 } from "src/shared/types";
import { postCategory, putCategory } from "src/shared/api";

interface CategoryPageResponse {
  category_details: CategoryV2[];
  totalCount?: number;
  totalPages?: number;
  currentPage?: number;
  [key: string]: any;
}

const useCategory = (
  reFresh: boolean = false,
  Deleted?: boolean,
  page?: number,
  row?: number,
  search?: string,
  sortField?: string,
  order?: string,
) => {
  const [category, setCategory] = useState<CategoryV2[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [categoryPage, setCategoryPage] = useState<CategoryPageResponse | null>(null);
  const [error, setError] = useState<any>(null);

  const getData = () => {
    getCategory(Deleted, page, row, search, sortField, order)
      .then((res) => {
        const filtered: CategoryV2[] = res.data.categoryDetails;
        setCategory(filtered);
        setCategoryPage(res.data);
      })
      .catch((err) => {
        console.error(err);
        setError(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    const timer = setTimeout(() => {
      getData();
    }, 3000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reFresh, Deleted, search, page, row, sortField, order]);

  const DeleteCategory = async (ids: string[]) => {
    setLoading(true);
    try {
      deleteCategory(ids).then((res) => {
        getData();
        notifySuccess("Category deleted successfully!");
      });
    } catch (error) {
      errorHandling(error);
    } finally {
      setLoading(false);
    }
  };

  const post = (data: { categoryName: string; categorySecondName: string }, sucess: (data: any) => void) => {
    setLoading(true);
    notifyLoading("Adding category...");
    try {
      postCategory(data).then((res) => {
        getData();
        closeLoading();
        notifySuccess("Category added successfully!");
        sucess("Updated");
        return res;
      });
    } catch (error) {
      closeLoading();
      errorHandling(error);
    } finally {
      setLoading(false);
    }
  };

  const edit = (id: string, data: { categoryName?: string; categorySecondName?: string }, sucess: (data: any) => void) => {
    setLoading(true);
    notifyLoading("Editing category...");
    try {
      putCategory(id, data).then((res) => {
        getData();
        closeLoading();
        sucess("Updated");
        notifySuccess("Category edited successfully!");
        return res;
      });
    } catch (error) {
      closeLoading();
      errorHandling(error);
    } finally {
      setLoading(false);
    }
  };

  return { category, loading, categoryPage, error, DeleteCategory, post, edit };
};

export default useCategory;
